import React from "react";
import { X } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";

interface Props {
  images: string[];
  open: boolean;
  onClose: () => void;
}

const FullscreenImageModal: React.FC<Props> = ({ images, open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/90 z-[9999] flex flex-col items-center justify-center">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 p-2 bg-white/80 rounded-full"
      >
        <X className="text-black" size={24} />
      </button>

      {/* Fullscreen Carousel */}
      <div className="w-full max-w-5xl">
        <Carousel className="w-full">
          <CarouselContent>
            {images.map((img, index) => (
              <CarouselItem key={index}>
                <img
                  src={img}
                  className="w-full max-h-[90vh] object-contain rounded-md"
                />
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselPrevious className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 text-black border-none" />
          <CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 text-black border-none" />
        </Carousel>
      </div>
    </div>
  );
};

export default FullscreenImageModal;
